import React from 'react';
import './Footer.css';
import logoIcon from '../assets/images/footer-logo.png';

function Footer() {
  return (
    <footer className="footer" id="footer">
      <div className="footer-container">
        <div className="footer-logo">
          <img src={logoIcon} alt="Eleven Power" />
        </div>
        <div className="footer-contact">
          <div className="footer-contact-item">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M2 4L8 8.5L14 4" stroke="#22a652" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
              <rect x="1" y="3" width="14" height="10" rx="2" stroke="#22a652" strokeWidth="1.5"/>
            </svg>
            <span>connect@elevenpower.in</span>
          </div>
          <div className="footer-contact-item">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3 2H6L7.5 5.5L5.5 7C6.5 9 7 9.5 9 10.5L10.5 8.5L14 10V13C14 13.5523 13.5523 14 13 14C7.47715 14 3 9.52285 3 4C3 3.44772 3.44772 3 4 3" stroke="#22a652" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
            <span>0124-4834600</span>
          </div>
          <div className="footer-contact-item">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <circle cx="8" cy="6" r="3" stroke="#22a652" strokeWidth="1.5"/>
              <path d="M8 14C8 14 13 10 13 6C13 3.23858 10.7614 1 8 1C5.23858 1 3 3.23858 3 6C3 10 8 14 8 14Z" stroke="#22a652" strokeWidth="1.5"/>
            </svg>
            <span>5th Floor, Tower B,<br />Eleven Bay, Sector - 38,<br />Gurugram Haryana, India - 122001.</span>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
